export enum WarehouseMaterialOperationTypeEnum {
    RETURNED = 'returned',
    ISSUED = 'issued',
    RECEIPT = 'receipt',
}
